import React, { useEffect, useState } from 'react';
import config from '../config';
import Icon from './Icons';
import './Navbar.css';

const links = [
  { href: '#vozidlo', label: 'Vozidlo' },
  { href: '#galeria', label: 'Galéria' },
  { href: '#cennik', label: 'Cenník' },
  { href: '#rezervacia', label: 'Rezervácia' },
  { href: '#faq', label: 'FAQ' },
  { href: '#kontakt', label: 'Kontakt' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled || open ? 'nav--solid' : ''}`}>
      <div className="container nav__inner">
        <a href="#uvod" className="nav__brand" onClick={() => setOpen(false)}>
          <img src="/images/California%20logo.png" alt="California Košice" className="nav__logo" />
        </a>

        <nav className={`nav__links ${open ? 'nav__links--open' : ''}`} aria-label="Hlavná navigácia">
          {links.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
          <a href="#rezervacia" className="btn btn--primary nav__cta" onClick={() => setOpen(false)}>
            Pozri kalendár
          </a>
        </nav>

        <a href={`tel:${config.phoneHref}`} className="nav__phone" aria-label={`Zavolať na ${config.phone}`}>
          <Icon name="phone" size={18} />
          <span>{config.phone}</span>
        </a>

        <button
          className="nav__burger"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label={open ? 'Zavrieť menu' : 'Otvoriť menu'}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
